/**
 * Per-screen chrome, declared on the route rather than pushed up from the screen.
 *
 * The shell needs three things from whatever is in the outlet: the breadcrumb
 * trail, the title for the MyOrange webview bar, and whether the page is the wide
 * or the narrow measure. All three are fixed per screen, so they belong on the
 * route where they can be read before the component is instantiated — a screen
 * that set them in `ngOnInit` would render one frame with the previous screen's
 * breadcrumbs, which is visible on a slow device.
 */
import type { ScreenId } from './flow-steps';

export interface PageMeta {
  /** Stable screen id, per CLAUDE.md §Conventions. Absent for non-flow pages. */
  readonly screen?: ScreenId;
  /** Breadcrumb trail. Last item is the current page and is not a link. */
  readonly crumbs: readonly string[];
  /** Title for the webview bar, which has no room for a trail. */
  readonly webviewTitle: string;
  /** 1140px or 680px. Defaults to wide. */
  readonly width?: 'wide' | 'narrow';
  /** Whether the step bar appears. False for entry, confirmation and order pages. */
  readonly steps?: boolean;
}

/** Route `data` shape. `data: pageMeta({ ... })` keeps the key spelled one way. */
export const pageMeta = (meta: PageMeta): { readonly meta: PageMeta } => ({ meta });
